import { render, staticRenderFns } from "./RedactorConfirmModal.vue?vue&type=template&id=56a284e9&"
import script from "./RedactorConfirmModal.vue?vue&type=script&lang=js&"
export * from "./RedactorConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports